"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEEDS_A_URL_LABEL = exports.LinksNeedingAddressIndicator = void 0;
exports.linkNeedingAddressSentenceOf = linkNeedingAddressSentenceOf;
exports.linksNeedingAddressOf = linksNeedingAddressOf;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _utils = require("@design/lib/utils");
var _CommentAnchorContext = require("./CommentAnchorContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var INDICATOR_LOOK_OF_DENSITY = {
  chatCard: {
    textClass: "text-[11px] text-[#B45309]",
    iconSize: 14,
    namesTheWrittenTexts: true
  },
  drawerRow: {
    textClass: "text-[11px] text-[#92400E]",
    iconSize: 12,
    namesTheWrittenTexts: true
  },
  drawerMember: {
    textClass: "flex-shrink-0 text-[10px] text-[#92400E]",
    iconSize: 11,
    namesTheWrittenTexts: false
  }
};
var NEEDS_A_URL_LABEL = exports.NEEDS_A_URL_LABEL = "Needs a URL";
function isLinkNeedingAddress(linkInstruction) {
  return linkInstruction.action === "needs_url";
}
function linksNeedingAddressOf(textRedline) {
  if (textRedline === null) return [];
  return textRedline.paragraphs.flatMap(function (cardParagraph) {
    var _cardParagraph$linkIn;
    return ((_cardParagraph$linkIn = cardParagraph.linkInstructions) !== null && _cardParagraph$linkIn !== void 0 ? _cardParagraph$linkIn : []).filter(isLinkNeedingAddress);
  });
}
function replacedLinkAddressOf(linkNeedingAddress) {
  if (linkNeedingAddress.linkAddress === null) return "an address that could not be read";
  return linkNeedingAddress.linkAddress;
}
function linkNeedingAddressSentenceOf(linkNeedingAddress) {
  return "".concat(NEEDS_A_URL_LABEL, ": \"").concat((0, _CommentAnchorContext.snippetOf)(linkNeedingAddress.writtenText), "\" replaces the link \"").concat((0, _CommentAnchorContext.snippetOf)(linkNeedingAddress.linkText), "\" to ").concat(replacedLinkAddressOf(linkNeedingAddress), ".");
}
function indicatorLabelOf(linksNeedingAddress, look) {
  if (!look.namesTheWrittenTexts) return NEEDS_A_URL_LABEL;
  return "".concat(NEEDS_A_URL_LABEL, " for ").concat(linksNeedingAddress.map(function (linkNeedingAddress) {
    return "\"".concat((0, _CommentAnchorContext.snippetOf)(linkNeedingAddress.writtenText), "\"");
  }).join(", "));
}
var LinksNeedingAddressIndicator = exports.LinksNeedingAddressIndicator = function LinksNeedingAddressIndicator(_ref) {
  var linksNeedingAddress = _ref.linksNeedingAddress,
    density = _ref.density;
  if (linksNeedingAddress.length === 0) return null;
  var look = INDICATOR_LOOK_OF_DENSITY[density];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    role: "status",
    "data-testid": "links-needing-address",
    title: linksNeedingAddress.map(linkNeedingAddressSentenceOf).join("\n"),
    className: (0, _utils.cn)("flex min-w-0 items-center gap-1 font-medium", look.textClass),
    "data-sentry-component": "LinksNeedingAddressIndicator",
    "data-sentry-source-file": "LinksNeedingAddressIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.AlertTriangle, {
      size: look.iconSize,
      className: "flex-shrink-0 text-[#F59E0B]",
      "aria-hidden": "true",
      "data-sentry-element": "AlertTriangle",
      "data-sentry-source-file": "LinksNeedingAddressIndicator.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "min-w-0",
      children: indicatorLabelOf(linksNeedingAddress, look)
    })]
  });
};